// Image List for Bank Statement
export const IMAGE_LIST = [
    // { id: "32", url: 'assets/images/Standard_Chartered.png', name: 'Standard Chartered', selected: false },
    { id: "20", url: 'assets/images/HDFC_Bank.png', name: 'HDFC Bank', selected: false },
    { id: "2", url: 'assets/images/Axis-Bank.png', name: 'Axis Bank', selected: false },
    // { id: 3, url: 'assets/images/Citi_Bank.png', name: 'City Bank', selected: false },
    { id: "22", url: 'assets/images/ICICI_Bank.png', name: 'ICICI Bank', selected: false },
    // { id: "21", url: 'assets/images/HSBC_Bank.png', name: 'HSBC Bank', selected: false },
    { id: "140", url: 'assets/images/IDFC.png', name: 'IDFC First Bank', selected: false },
    { id: "35", url: 'assets/images/SBI.png', name: 'SBI Bank', selected: false },
    { id: "44", url: 'assets/images/United_bank_of_India.png', name: 'United Bank of India', selected: false },
    { id: "9", url: 'assets/images/Bank_of_India.png', name: 'Bank of India', selected: false },
    { id: "28", url: 'assets/images/Kotak.png', name: 'Kotak Mahindra Bank', selected: false },
    { id: "30", url: 'assets/images/Punjab_Bank.png', name: 'Punjab National Bank', selected: false },
    { id: "24", url: 'assets/images/Indian_Bank.png', name: 'Indian Bank', selected: false }
]

export const LOAN_MONTHS = [
    { value: 6 },
    { value: 7 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
    { value: 11 },
    { value: 12 },
    { value: 13 },
    { value: 14 },
    { value: 15 },
    { value: 16 },
    { value: 17 },
    { value: 18 },
    { value: 19 },
    { value: 20 },
    { value: 21 },
    { value: 22 },
    { value: 23 },
    { value: 24 },
    { value: 25 },
    { value: 26 },
    { value: 27 },
    { value: 28 },
    { value: 29 },
    { value: 30 },
    { value: 31 },
    { value: 32 },
    { value: 33 },
    { value: 34 },
    { value: 35 },
    { value: 36 },
]

export const LOAN_TURNOVER = [
    { label: '0 - 3 lakh', value: 299999 },
    { label: '3 - 12 lakh', value: 1199999 },
    { label: '12 - 30 lakh', value: 2999999 },
    { label: '30 - 60 lakh', value: 5999999 },
    { label: '60 - 1 crore', value: 9999999 },
    { label: '1 - 10 crore', value: 99999999 },
    { label: '>= 10 crore', value: 100000000 }
]

// Upload Document List
export const UPLOAD_DOCUMENTS_MAPPER = [
    {
        title: 'Income Proof',
        tileStatus: '',
        pages: [
            {
                docName: 'bankStatement',
                docType: 'BANK_STATEMENT',
                pageTitle: 'Bank Statement',
                status: false,
                navigateURl: '/bil/upload-document/bank-statement',
                hint: 'Last 6 months'
            },
            {
                docName: 'itr',
                docType: 'ITR',
                pageTitle: 'ITR',
                status: false,
                navigateURl: '/bil/upload-document/itr',
                hint: 'Last 2 Years'
            }
        ]
    },
    {
        title: 'Entity KYC',
        tileStatus: '',
        pages: [
            {
                pageTitle: 'Registration Proof',
                docType: 'REGISTRATION_PROOF',
                status: false,
                navigateURl: '/bil/upload-document/registration-proof'
            }
        ]
    },
    {
        title: 'Owner KYC',
        tileStatus: '',
        pages: [
            {
                pageTitle: 'Upload PAN and Address Proof',
                status: false,
                navigateURl: '/bil/upload-document/add-partner'
            }
        ]
    }
]

//Urls
export const PRIVACY_URL: string = 'https://www.solvezy.com/privacy-policy/';
export const TERM_CONDITIONS_URL: string = 'https://www.solvezy.com/terms-of-services/';

//constant text
export const CHANGE_DOCUMENT_TEXT: string = 'Are you sure you want to change the document type? ';
export const ITR_DOCUMENT_DELETE_TEXT: string = 'Are you sure you want to delete the ITR Document? ';
export const BS_DOCUMENT_DELETE_TEXT: string = 'Are you sure you want to delete the bank statements? ';
export const CHANGE_DOCUMENT_SUBHEADING = 'Document uploaded earlier will be deleted.';
export const UPLOAD_BACK: string = 'Are you sure you want to go back ?';
export const DOC_LOST_ALERT: string = 'Uploaded document(s) will not be saved.';
export const UPLOAD_DOCUMENT_BACK: string = 'Are you sure you want to go back . Document uploaded earlier will be lost.';
export const REMOVE_PARTNER_TEXT: string = 'Are you sure you want to remove this partner ?';
export const REMOVE_DIRECTOR_TEXT: string = 'Are you sure you want to remove this director ?';
export const REMOVE_DOCUMENT_TEXT: string = 'Are you sure you want to delete this document ?';
export const APP_SUBMISSION_CONFIRM_TEXT: string = 'Please confirm the details of your application before submission.';
export const APP_SUBMISSION_CONFIRM_WARNING: string = 'Application once submitted can not be undone.';
export const BANK_STATEMENT_UPLOAD_CONFIRM_TEXT: string = 'Please ensure that you have uploaded the correct bank statements before saving.';
export const BANK_STATEMENT_UPLOAD_CONFIRM_WARNING: string = 'Once saved it can not be deleted';
export const PAN_GST_SAVE_WARNING: string = 'Please ensure that your business PAN/GST details are correct. You cannot change the business PAN/GST details after clicking on save';
export const DUPLICATE_PARTNER_NAME: string = 'It seems like you are adding partner with same name. Make sure you will be adding relevant KYC docs.';
export const DUPLICATE_DIRECTOR_NAME: string = 'It seems like you are adding director with same name. Make sure you will be adding relevant KYC docs.';
export const REMOVE_TEXT: string = ' has been removed.';
export const MAX_NUMBER_OF_ITR_DOCS: number = 2;
